/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiResponseChallenge } from '../model/models';
import { ApiResponseChallengeSummary } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface ChallengeServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     */
    challengeControllerFindActive0(extraHttpRequestParams?: any): Observable<Array<ApiResponseChallenge>>;

    /**
     * 
     * 
     */
    challengeControllerFindActive1(extraHttpRequestParams?: any): Observable<Array<ApiResponseChallenge>>;

    /**
     * 
     * 
     */
    challengeControllerFindLastFinishedForUser0(extraHttpRequestParams?: any): Observable<object>;

    /**
     * 
     * 
     */
    challengeControllerFindLastFinishedForUser1(extraHttpRequestParams?: any): Observable<object>;

    /**
     * 
     * 
     */
    challengeControllerFindPast0(extraHttpRequestParams?: any): Observable<Array<ApiResponseChallenge>>;

    /**
     * 
     * 
     */
    challengeControllerFindPast1(extraHttpRequestParams?: any): Observable<Array<ApiResponseChallenge>>;

    /**
     * 
     * 
     */
    challengeControllerGetSummaryByChallengeId0(extraHttpRequestParams?: any): Observable<ApiResponseChallengeSummary>;

    /**
     * 
     * 
     */
    challengeControllerGetSummaryByChallengeId1(extraHttpRequestParams?: any): Observable<ApiResponseChallengeSummary>;

}
